import React, { FunctionComponent } from 'react';
import { useForm } from 'react-hook-form';

import { SubmitButton } from 'components';
import { InputFormatQuestion } from 'scenes/common/components/Questions';

import { LandlordFullPageProps } from 'scenes/landlord/types';
import { getWeeklyRentPaid } from 'scenes/landlord/selectors';

export const QUESTION = 'What is the weekly rent paid by the tenants?';
export const STATE_KEY = 'weeklyRentPaid';
export const MAX_LENGTH = 9;

const RentalAgreementStep: FunctionComponent<LandlordFullPageProps> = ({
  funnelState,
  onNext,
}) => {
  const { formState: hooksForm, handleSubmit, errors, control } = useForm({
    mode: 'onChange',
  });

  const weeklyRentPaid = getWeeklyRentPaid(funnelState);

  return (
    <form onSubmit={handleSubmit(onNext)}>
      <InputFormatQuestion
        size={4}
        prefix="$"
        errors={errors}
        ariaRequired
        placeholder="$0"
        decimalScale={0}
        control={control}
        stateKey={STATE_KEY}
        question={QUESTION}
        maxLength={MAX_LENGTH}
        defaultValue={weeklyRentPaid}
        validationRules={{ required: true }}
      />
      <SubmitButton enabled={hooksForm.isValid}>Next</SubmitButton>
    </form>
  );
};

export default RentalAgreementStep;
